var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.block?.paragraph)?_c('div',{staticClass:"grid-container"},_vm._l((_vm.block.paragraph),function(paragraph,index){return _c('div',{key:index,staticClass:"grid-item"},[_c('p',[_vm._v("\n      "+_vm._s(paragraph.text)+"\n    ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }